import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { SubscriptionBasedComponent } from '../../../subscription-helpers/subscription-based.component';
import { Project } from '../../../model/project/project';
import {
  MatLegacyDialog as MatDialog,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { QuotationSitevisitPendingComponent } from '../../../modals/quotation-sitevisit-pending/quotation-sitevisit-pending.component';
import { RequestService } from '../../../services/request.service';
import ProjectHelper from '../../../helpers/project-helper';
import BrowserHelper from '../../../helpers/browser-helper';
import { SubProject } from '../../../model/project/sub-project';
import { Pickup } from '../../../model/project/pickup';
import { Adjustment } from '../../../model/project/adjustment';
import Employee from '../../../model/product/employee';
import { Subject } from 'rxjs';
import { ModalService } from 'src/app/services/modal.service';
import UserHelper from 'src/app/helpers/user-helper';
import { User } from 'src/app/model/user';
import { SnackService } from 'src/app/services/snack.service';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import Asset from 'src/app/model/asset';
import { NotificationMailComponent } from 'src/app/modals/notification-mail/notification-mail.component';

@Component({
  selector: 'edit-adjustment',
  templateUrl: './edit-adjustment.component.html',
  styleUrls: ['../../../pages/projects/edit/edit-project.component.scss'], // TODO legacy mistake, changing this to './edit-adjustment.component.scss' breaks styling, fix this
})
export class EditAdjustmentComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  @ViewChild('actualPlacementDateInput')
  actualPlacementDateInput: ElementRef<HTMLInputElement>;

  isCollapsedCompany: boolean;
  isCollapsedProject: boolean;
  isCollapsedPlacement: boolean;
  isCollapsedAdjustment: boolean;
  isCollapsedSoldRented: boolean;
  isCollapsedRepo: boolean;
  isCollapsedOverview: boolean;
  isCollapsedBilling: boolean;
  isHiddenProject: boolean;
  isHiddenPlacement: boolean;
  isHiddenAdjustment: boolean;
  isHiddenSoldRented: boolean;
  isHiddenOverview: boolean;
  isHiddenBilling: boolean;
  init = false;
  @Input()
  project = new Project();
  @Input()
  model = new Adjustment();
  @Input()
  client = false;
  @Input()
  loadSubProject = false;
  @Output()
  public save = new EventEmitter();
  @Output()
  public deleted = new EventEmitter();

  @Output()
  public immediateSave = new EventEmitter();

  invoiceSent = new Subject<any>();

  subProjectTitle: string;
  bannerContainerClass: string;

  safari: boolean;
  private dialogModalRef: MatDialogRef<QuotationSitevisitPendingComponent>;
  public employeeChoices: Employee[] = [];
  disableDelete = false;
  generatingPlacementSticker = false;

  constructor(
    private requestService: RequestService,
    private dialog: MatDialog,
    private modalService: ModalService,
    private snackService: SnackService
  ) {
    super();
    this.isHiddenBilling = true;
    this.isHiddenPlacement = true;
    this.isHiddenAdjustment = true;
    this.isHiddenSoldRented = true;
    this.isHiddenProject = true;
    this.isHiddenOverview = true;
    this.expandCompany(false);
  }

  ngOnInit() {
    this.subProjectTitle = ProjectHelper.getFormDisplayNameUpperCase(
      this.model
    );
    this.bannerContainerClass = ProjectHelper.getTypeStatusString(this.model);
    this.getEmployees();
    this.safari = BrowserHelper.isSafari();
    if (this.client) {
      if (this.model.pickup == null) {
        this.model.pickup = new Pickup();
      }
      this.init = true;
      return;
    }
    if (this.model.id) {
      this.isCollapsedCompany = true;
      this.isHiddenProject = false;
      this.isHiddenPlacement = false;
      this.isHiddenOverview = false;
      this.isHiddenAdjustment = false;
      this.isHiddenSoldRented = false;
      this.isHiddenBilling = false;
      this.initSubProject(this.model);
    } else {
      this.model.withPlacement = true;
      this.isCollapsedCompany = true;
      this.isHiddenProject = false;
      this.isHiddenPlacement = false;
      this.isHiddenOverview = false;
      this.isHiddenAdjustment = false;
      this.isHiddenSoldRented = false;
      this.isHiddenBilling = false;
      this.init = true;
    }
    if (this.invoiceSent != null) {
      this.addSubscription(this.invoiceSent, () => {
        this.disableDelete = true;
      });
    }
  }

  getEmployees() {
    this.addSubscription(
      this.requestService.get('employees/withType/PLACER'),
      (result) => {
        this.employeeChoices = <Employee[]>result.body;
      }
    );
  }

  initSubProject(subproject: SubProject): SubProject {
    this.model = subproject;
    if (this.model.pickup == null) {
      this.model.pickup = new Pickup();
    }
    this.disableDelete =
      this.model.projectInvoices != null &&
      this.model.projectInvoices.some((pi) => pi.teamleaderId != null);
    this.init = true;
    return subproject;
  }

  collapseAllSections() {
    this.isCollapsedCompany = true;
    this.isCollapsedProject = true;
    this.isCollapsedAdjustment = true;
    this.isCollapsedSoldRented = true;
    this.isCollapsedRepo = true;
    this.isCollapsedPlacement = true;
    this.isCollapsedOverview = true;
    this.isCollapsedBilling = true;
  }

  openActions() {
    const setSubProjectSubject = new Subject<SubProject>();
    this.addSubscription(
      setSubProjectSubject,
      (subProject: SubProject) => (this.model = subProject)
    );
    let config = {
      project: this.project,
      subProject: this.model,
      loadProject: true,
      setSubProjectSubject: setSubProjectSubject,
    };
    this.dialogModalRef = this.dialog.open(QuotationSitevisitPendingComponent, {
      data: config,
    });
    this.addSubscription(
      this.dialogModalRef.afterClosed(),
      (project: Project) => {
        if (project) {
          this.model = project.subProjects.find(
            (subProject) => subProject.id === this.model.id
          );
          this.saveSubProject();
        }
        setSubProjectSubject.complete();
      }
    );
  }

  openNotificationMailModal() {
    const config = {
      userOptions: ProjectHelper.getInvolvedSubprojectUsers(this.model).filter(
        (u) => u.email != null && u.email.toString() !== ''
      ),
      project: this.project,
      subProjectId: this.model.id,
      showQuotationAddress: false,
      selectAll: false,
      performSend: true,
    };
    this.dialog.open(NotificationMailComponent, { data: config });
  }

  expandCompany(value: boolean) {
    this.collapseAllSections();
    this.isCollapsedCompany = value;
  }
  saveSubProject() {
    this.save.emit(this.model);
  }

  saveExAdjustment() {
    this.saveSubProject();
  }

  saveGeneralInternalAdjustment() {
    this.saveSubProject();
  }

  saveInAdjustment() {
    this.saveSubProject();
  }

  deleteSubProject() {
    this.modalService.confirmDialog(
      'Verwijderen subproject',
      'Bent u zeker dat u dit subproject wilt verwijderen?',
      (answer) => {
        if (answer) {
          this.addSubscription(
            this.requestService.delete('/subprojects/archive/' + this.model.id),
            () => {
              this.model.archived = true;
              this.deleted.emit();
            }
          );
        }
      }
    );
  }

  getName(employee: Employee) {
    return UserHelper.getName(employee.user);
  }

  getUserLetters(user: User) {
    return UserHelper.getLettres(user);
  }

  getUserName(user: User) {
    return UserHelper.getName(user);
  }

  generatePlacementSticker() {
    this.generatingPlacementSticker = true;
    this.addSubscription(
      this.requestService.post(
        {},
        'subprojects/generatePlacementSticker/' + this.model.id
      ),
      (res) => {
        if (res.success === false) {
          this.snackService.showError(res.message);
        } else {
          GeneralHelper.downloadAsset(<Asset>res);
        }
        this.generatingPlacementSticker = false;
      },
      (err) => {
        this.snackService.showError(err);
        this.generatingPlacementSticker = false;
      }
    );
  }
}
